import { cn } from '@repo/lib/cn';
import { useImperativeHandle, useRef } from 'react';

import type { AudioPlayerProps } from '.';

import { MediaProvider, PlayerTime, PlayStopButton, ProgressBar, SkipBackButton, SkipForwardButton, useMediaStore, VolumeControl } from '.';

export function AudioPlayer(audioPlayerProps: AudioPlayerProps) {
  const { children, src, className, ref, ...props } = audioPlayerProps;

  const audioRef = useRef<HTMLAudioElement>(null);
  const mediaStore = useMediaStore(audioRef);

  useImperativeHandle(ref, () => audioRef.current!, []);

  return (
    <MediaProvider store={mediaStore}>
      <div className={cn('@container flex w-full items-center gap-2', className)}>
        <audio ref={audioRef} src={src} {...props} />
        {children || (
          <>
            {/* Control Buttons */}
            <div className="flex gap-0.5">
              <SkipBackButton className={'hidden @md:flex'} />
              <PlayStopButton />
              <SkipForwardButton className={'hidden @md:flex'} />
            </div>

            <div className="flex items-center gap-1">
              <PlayerTime type="current" />
              <span className="text-muted-foreground text-xs">/</span>
              <PlayerTime type="duration" className={'text-muted-foreground'} />
            </div>
            {/* Progress Bar */}
            <ProgressBar />
            <VolumeControl />
          </>
        )}
      </div>
    </MediaProvider>
  );
}
